<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title>1.9 - {{ $t('Resolutividade Interna') }}</v-card-title>
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!haveData">
      {{ $t('Nenhum resolutividade encontrada') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <BarChart
            :chart-data="internalResolvabilityChartData"
            :options="options"
          />
        </v-col>
      </v-row>

      <v-simple-table class="main-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th
                class="text-left"
                v-for="month in data.dataByMonth.map((x) => x.month)"
                :key="month"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">{{ $t('Internas') }}</td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalInternal }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">{{ $t('Externas') }}</td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalServiceOrders - item.totalInternal }}
              </td>
            </tr>
            <tr style="background: #0288d1">
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px; color: white !important">
                Porcentagem
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.percentage}%` }}
              </td>
            </tr>
            <!-- <tr style="background: orange">
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px; color: white !important">Meta</td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${data.goal}%` }}
              </td>
            </tr> -->
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.gauge {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 600px) {
  .gauge {
    height: 50vh !important;
  }
}
</style>

<script>
import ApiService from '../../../../../../services/ApiService'
import BarChart from '../../../../Reports/components/charts/barChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      internalResolvability: undefined,
      page: 1,
      exampleValue: 50,
      totalPages: 1,
      pageSize: 7,
      val: 5,
      percent: 0,
      options: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      optionsGauge: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        series: [
          {
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.3, '#ED8990'],
                  [0.7, '#FDB578'],
                  [1, '#BCD504'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 1,
              },
            },
            splitLine: {
              distance: -20,
              length: 20,
              lineStyle: {
                color: '#fff',
                width: 3,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 15,
              fontSize: 10,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              color: 'auto',
              fontSize: 10,
            },
            data: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      internalResolvabilityChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      internas: [],
      internasMaisExternas: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },

  async created() {
    this.listInternalResolvability()
  },

  computed: {
    haveData() {
      return this.data.dataByMonth.length > 0
    },
  },

  methods: {
    async listInternalResolvability() {
      await this.apiService
        .post('bigData/internalResoluteness', this.filter)
        .then((response) => {
          this.data = response.content
          this.internalResolvability = [this.data]
        })
        .catch((err) => {})

      this.fillinternalResolvabilityChartData()
    },
    fillinternalResolvabilityChartData() {
      this.internalResolvabilityChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: 'Execução total',
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#0288d1',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listInternalResolvability()
    },
    percent(nv, ov) {
      this.optionsGauge.series[0].data[0].value = nv
    },
  },
}
</script>
